// --------------------------------------------------------------------------
// #28 - HEADER
//     - handles the off canvas nav
// --------------------------------------------------------------------------
// Author:      Sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var $toggleNavButton = $('<span class="mobile-nav-button">Menu</span>');
    var $contentMask = $('<span class="content-mask"></span>');
    var $innerWrapper = context.find('.inner-wrapper');
    var $offCanvasNavigation = context.find('.primary-nav');
    var isMobile = false;

    /// Set varibles for navigation delay hovers
    var hoverClass = 'hover';
    var hoverTriggered = false;
    var navEventsSet = false;
    var hoverActive = false; /// Boolean to prevent desktop hover function firing multiple
    var currentHover;
    var animationEnabled = true; /// Affects first hover timeout delay

    /// Timeout functions
    // TODO: could/should these timeout functions be consolidated?
    var displayTimeout;
    var hideTimeout;
    var resizeTimeout;

    /**
     * Class name removal
     */
    function addDesktopNavHover(trigger) {
        if (hoverActive === false) {
            trigger.parents('.primary-nav__nav-item').addClass(hoverClass);
            trigger.parents('.nav-tier-two__nav-item').addClass(hoverClass);
            trigger.parents('.nav-tier-three__nav-item').addClass(hoverClass);

            hoverActive = true;
        }
    }

    function removeDesktopNavHover(trigger) {
        if (hoverActive === true) {
            trigger.parents('.primary-nav__nav-item').removeClass(hoverClass).siblings('.primary-nav__nav-item').removeClass(hoverClass);

            trigger.parents('.primary-nav__nav-item');
            trigger.parents('.nav-tier-two__nav-item').removeClass(hoverClass);
            trigger.parents('.nav-tier-three__nav-item').removeClass(hoverClass);

            hoverActive = false;
        }
    }

    function addTierTwoNavHover(trigger) {
        trigger.parents('.nav-tier-two__nav-item').addClass(hoverClass);
    }

    function removeTierTwoNavHover(trigger) {
        trigger.parents('.nav-tier-two__nav-item').removeClass(hoverClass).siblings('.nav-tier-two__nav-item').removeClass(hoverClass);
    }

    /**
     * Delays the mega menu displaying
     */
    function delayHoverIn(trigger) {

        /// Clears hiding timeout if hovering over same item
        if (currentHover) {
            if (trigger.parent().index() === currentHover.parent().index()) {
                clearTimeout(hideTimeout);
            }
        }
        hoverTriggered = true;
        displayTimeout = setTimeout(function () {
            addDesktopNavHover(trigger);
        }, animationEnabled ? 200 : 0); /// Faux hover intent: If it is first hover, wait before triggering classes.
    }

    /**
     * Delays the mega menu hiding
     */
    function delayHoverOut(trigger) {
        currentHover = trigger;

        /// Clears displaying timeout if one was started
        if (hoverTriggered === true) {
            clearTimeout(displayTimeout);
            hoverTriggered = false;
        }

        hideTimeout = setTimeout(function () {
            removeDesktopNavHover(trigger);
        }, 0); /// Hide immediately
    }

    /**
     * Add class to parent if has children (by class name)
     */
    function hasChildren(parentClass, childClass) {

        /// Find the parent
        var $items = $offCanvasNavigation.find('.' + parentClass);

        $.each($items, function () {
            var $this = $(this);

            /// If it has children
            if ($this.find('.' + childClass).length > 0) {
                $this.addClass('has-children');
            }
        });
    }

    /**
     * Set nav events
     */
    function setNavEvents() {
        if (isMobile === false) {
            navEventsSet = true;
            $('.primary-nav').on({
                mouseenter: function mouseenter() {

                    /// Toggle classes to disable menu fade in
                    setTimeout(function () {
                        $offCanvasNavigation.removeClass('enable-animation').addClass('disable-animation');

                        /// Animation is disabled
                        animationEnabled = false;
                    }, 700); /// Wait for css transitions
                },
                mouseleave: function mouseleave() {

                    /// Toggle animation classes
                    setTimeout(function () {
                        $offCanvasNavigation.removeClass('disable-animation').addClass('enable-animation');

                        /// Animation is enabled
                        animationEnabled = true;
                    }, 0); /// Wait for css transitions
                }
            });

            /**
             * Add accessible tabbing to anchors
             */
            $('.primary-nav__nav-list').find('a').on({
                focus: function focus() {
                    addDesktopNavHover($(this));
                },
                blur: function blur() {
                    removeDesktopNavHover($(this));
                },
                click: function click() {
                    addDesktopNavHover($(this));
                }
            });

            /**
             * Add mouse events for top nav items
             */
            $('.primary-nav__nav-list').find('.primary-nav__nav-item').on({
                mouseover: function mouseover() {
                    delayHoverIn($(this).children('a'));
                },
                mouseout: function mouseout() {
                    delayHoverOut($(this).children('a'));
                }
            });

            /**
             * Add mosue events for tier three items
             */
            $('.nav-tier-three').on({
                mouseover: function mouseover() {
                    addTierTwoNavHover($(this));
                },
                mouseout: function mouseout() {
                    removeTierTwoNavHover($(this));
                }
            });
        }
    }

    /**
     * Set the nav height
     */
    function setNavHeight() {

        /// Desktop first
        if (isMobile === false) {
            /// Mouseover of primary nav links
            $('.primary-nav__nav-item').mouseover(function () {
                var $tierTwoItems = $(this).find('.nav-tier-two__nav-item');
                var $tierTwo = $(this).find('.nav-tier-two');
                var height = 0;
                var itemHeight = 0;
                var i;

                /// loop through chldren within hovered item and find tallest
                for (i = 0; i < $tierTwoItems.length; i++) {
                    itemHeight = $($tierTwoItems[i]).children('.nav-tier-three').outerHeight();
                    if (itemHeight > height) {
                        height = itemHeight;
                    }
                }

                /// If tallest item is taller than overall nav, then set the height
                if (height > $tierTwo.outerHeight()) {
                    $tierTwo.css('height', height);
                    $tierTwoItems.children('.nav-tier-three').css('height', height);
                } else {
                    $tierTwoItems.children('.nav-tier-three').css('height', $tierTwo.outerHeight());
                }
            });
        } else {
            $('.primary-nav__nav-item').unbind();
            $('.nav-tier-two').css('height', 'auto');
            $('.nav-tier-three').css('height', 'auto');
        }
    }

    /**
     * Open slideout nav
     */
    function openNav() {
        $innerWrapper.addClass('is-open');
        $toggleNavButton.text('Close').addClass('close');
    }

    /**
     * Close slideout nav
     */
    function closeNav() {
        $innerWrapper.removeClass('is-open');
        $toggleNavButton.text('Menu').removeClass('close');
    }

    /**
     Init
     */
    function init() {
        /// Check if mobile
        if ($innerWrapper.find('.nav-tier-two').css('position') === 'relative') {
            isMobile = true;
        }

        setNavEvents();

        setNavHeight();

        /// Add class to enable css animations
        $offCanvasNavigation.addClass('enable-animation');

        /// Check tier two items for children
        hasChildren('nav-tier-two__nav-item', 'nav-tier-three');

        /**
         * Mobile Nav
         */

        /// Add open and close buttons
        $offCanvasNavigation.prepend($toggleNavButton);
        $innerWrapper.prepend($contentMask);

        /// Open and close nav with main "menu" button (moble)
        $toggleNavButton.on('click', function () {
            if ($innerWrapper.is('.is-open')) {
                closeNav();
            } else {
                openNav();
            }
        });

        /// Close nav by clicking  mask over content
        $contentMask.on('click', function () {
            closeNav();
        });

        /// Toggle mobile tier 2 & 3
        var $toggle = $offCanvasNavigation.find('.toggle');

        $toggle.on('click', function () {
            $(this).parent().toggleClass('is-open');
            $(this).next('ul').slideToggle();
        });

        $(window).resize(function () {

            clearTimeout(resizeTimeout);

            resizeTimeout = setTimeout(function () {
                /// Check if desktop - if so remove all styles
                if ($innerWrapper.find('.nav-tier-two').css('position') === 'relative') {
                    isMobile = true;
                    navEventsSet = false;
                } else {
                    isMobile = false;
                }
                if (isMobile === false) {
                    closeNav();
                    $innerWrapper.find('.primary-nav .is-open').removeClass('is-open');
                    context.find('.primary-nav ul').removeAttr('style');
                }

                /// Prevent nav events from being reset if resize doesn't switch between mobile and desktop nav
                if (navEventsSet === false) {
                    setNavEvents();
                }

                setNavHeight();
            }, 250);
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/main-navigation.js
// module id = 179
// module chunks = 0